import { registerWidgetUsage } from 'src/metrics/bilberryWidgetMetrics';
import { debugLog } from '@repo/common-utils/Logger';
import { configurationAtom } from '@repo/widget-utils/widgetsConfiguration';

export class BilberryCustomElementBase extends HTMLElement {
    constructor() {
        super();
    }

    private setupEventBlocking(): void {
        if (configurationAtom.subject.value.enableEventPropagation) {
            return; // Skip event blocking if propagation is enabled
        }

        const eventsToBlock = [
            'click',
            'mousedown',
            'mouseup',
            'touchstart',
            'touchend',
            'pointerdown',
            'pointerup',
            'mouseenter',
            'mouseleave',
            'focus',
            'blur',
        ];

        eventsToBlock.forEach((eventType) => {
            this.addEventListener(eventType, (e) => {
                e.stopImmediatePropagation();
            });
        });
    }

    protected connectedCallback(): void {
        debugLog('BilberryCustomElement connectedCallback for ', this.tagName);

        this.setupEventBlocking();

        if (!configurationAtom.subject.value.disableBilberryWidgetMetrics) {
            debugLog('Bilberry widget metrics are enabled. Registering...');
            registerWidgetUsage(this);
        } else {
            debugLog('Bilberry widget metrics are disabled');
        }
    }
}
